import * as API from "middleware/api";

export const listRequest = () => API.executeWithAccessToken("/communications.sendPre");
export default listRequest;
